import React, {Component} from "react";
import configs from '../../../configs.json'

class ForgotPassword extends Component {
    render() {
        return(
            <div className="container center" id='forgot-password'>
                <div className="card center-align" style={{backgroundColor: configs.colors.primary}}>
                    <div className="card-title" style={{borderBottom: '1px solid ' + configs.colors.secondary}}>
                        <h4>Esqueceu a senha</h4>
                    </div>
                    <form method="POST" encType="multipart/form-data" >
                        <div className="card-content white-text">
                            <div className="center">
                                <div className="row">
                                    <label for="input_text">Email</label>
                                    <input id="input_text" type="text" placeholder="exemplo@email.com" />
                                </div>
                            </div>
                        </div>
                        <div className="card-action" style={{borderTop: '1px solid ' + configs.colors.secondary}}>
                            <button type='submit' className="btn waves-effect waves-light" style={{backgroundColor: configs.colors.secondary}} >Enviar<i className="material-icons right">send</i></button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default ForgotPassword;